module.exports = __webpack_public_path__ + "img/Dantam Hair 10B.59d8f83f.jpg";